export { default as InsuranceManagementEdit } from './InsuranceManagementEdit';
export { default as InsuranceManagementList } from './InsuranceManagementList';
